module.exports = __webpack_public_path__ + "media/landing_page/fss1-cfb99683.jpg";